// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"wa_a bhi_b bhi_wb"};